import { render, staticRenderFns } from "./UserRequirePasswordChange.vue?vue&type=template&id=77a82a1d&"
import script from "./UserRequirePasswordChange.vue?vue&type=script&lang=ts&"
export * from "./UserRequirePasswordChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports